import PropTypes from 'prop-types'
import { Modal, Text, TextButton, PrimaryButton, IconButton, Icon } from '@artprov/design-system'

export default function ModalDescartarCambios({ open, setOpen, onCancel, onConfirm }) {
  const handleClose = () => {
    setOpen(false)
  }

  const handleCancel = () => {
    handleClose()
    onCancel?.()
  }

  const handleConfirm = () => {
    handleClose()
    onConfirm?.()
  }

  return (
    <Modal.Container open={open} setOpen={setOpen}>
      <Modal.Content width="min(95vw, 435px)" height="auto">
        <div className="py-5 px-5">
          {/* Icono de advertencia y botón cerrar */}
          <div className="flex justify-between items-start mb-5">
            <div className="w-full flex flex-col items-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center">
                <Icon icon="error" size="extra-large" variant="notification warning" />
              </div>
            </div>
            <IconButton
              icon="close"
              size="large"
              className="w-5 h-5 absolute top-4 right-4"
              onClick={handleClose}
              aria-label="Cerrar modal"
            />
          </div>

          {/* Título */}
          <div className="text-center mb-4">
            <Text variant="h5" className="text-primary-10 font-semibold text-center">
              Descartar cambios en el perfil
            </Text>
          </div>

          {/* Mensaje */}
          <div className="text-center mb-6">
            <Text variant="body1" className="text-tertiary-10 text-center">
              Si los descartás, se perderán los cambios realizados y se mantendrá la información anterior de tu perfil.
            </Text>
          </div>

          {/* Botones */}
          <div className="flex flex-col-reverse sm:flex-row justify-center gap-4">
            <TextButton
              onClick={handleCancel}
              size="small"
              descriptionTextVariant="button2"
              className="!h-[40px] !min-h-[40px] !px-4 whitespace-nowrap inline-flex items-center justify-center"
            >
              Continuar editando
            </TextButton>

            <PrimaryButton
              onClick={handleConfirm}
              size="small"
              descriptionTextVariant="button2"
              className="!h-[40px] !min-h-[40px] !px-6 whitespace-nowrap inline-flex items-center justify-center"
            >
              Descartar cambios
            </PrimaryButton>
          </div>
        </div>
      </Modal.Content>
    </Modal.Container>
  )
}

ModalDescartarCambios.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
}
